/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { VApplication } from "../../../application";
import { RECALL_UNUSED_INVITES } from "../graphql/recallUnused.mutation";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IRecallInviteMethods extends IPluginMethodMap {
  recallInviteUser(args: any): Promise<any>;
}

export class RecallInviteUserService implements IAgentPlugin {
  readonly methods: IRecallInviteMethods;

  constructor() {
    this.methods = {
      recallInviteUser: this.recallInviteUser.bind(this),
    };
  }

  async recallInviteUser(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log("args recall==>", args);
    try {
      if (client) {
        const res = await client.mutate({
          mutation: RECALL_UNUSED_INVITES,
          variables: {
            input: {
              userEmail: args?.userEmail,
              presentation: args?.presentation,
              partition: args?.partition,
              inviteType: args?.inviteType,
              sectionOptType: args?.sectionOptType,
              sections: args?.sections,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          console.log("res?.data==>", res?.data);
          return {
            ...res?.data?.sendPurchaseReferals,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
